import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'
import moment from 'moment'

Vue.use(Vuex)

const state = {
  tap: 0,
  quotes: [],
  quoting: [],
  quote: {
    details: []
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalQuotes: 0,
    totalPages: 0
  },
  pagination_quoting: {
    currentPage: 1,
    perPage: 5,
    totalQuotes: 0,
    totalPages: 0
  },
  quotesCatalog: {
    categories: ''
  },
  quotesCanceledCatalog: {
    cancelled: ''
  },
  filterParams: '',
  filterParamsQuoting: '',
  isModalVisible: false,
  isModalAmountVisible: false,
  isModalCategoriesVisible: false,
  isModalAssignedVisible: false
}

const mutations = {
  INIT_QUOTE_DETAIL (state, payload) {
    state.quote = payload
  },
  SET_QUOTES (state, payload) {
    state.quotes = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalQuotes: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_QUOTING (state, payload) {
    state.quoting = payload.data

    state.pagination_quoting = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalQuotes: payload.total,
      totalPages: payload.last_page
    }
  },
  UPDATE_QUOTE (state, payload) {
    const idx = state.quotes.findIndex(u => u.id === payload.id)
    const idy = state.quoting.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.quotes, idx, payload)
    } else if (idy >= 0) {
      Vue.set(state.quoting, idx, payload)
    }
  },
  UPDATE_QUOTING_TO_QUOTED (state, payload) {
    const idxQuoting = state.quotes.findIndex(u => u.id === payload.id)
    state.quotes.unshift(payload)
    state.quoting.splice(idxQuoting, 1)
  },
  UPDATE_QUOTE_ACTION (state, payload) {
    const idx = state.quotes.findIndex(u => u.id === payload.id)
    const idy = state.quoting.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.quotes, idx, payload)
    } else if (idy >= 0) {
      Vue.set(state.quoting, idy, payload)
    }
  },
  UPDATE_QUOTE_ACTION_STATE_CHANGE (state, payload) {
    const idx = state.quotes.findIndex(u => u.id === payload.id)
    const idy = state.quoting.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.quotes, idx, payload)
    } else if (idy >= 0) {
      Vue.set(state.quoting, idy, payload)
    }

    setTimeout(() => { Vue.delete(state.quotes, idx) }, 3000)
    setTimeout(() => { Vue.delete(state.quoting, idy) }, 3000)
  },
  DELETE_QUOTE (state, payload) {
    const idx = state.quotes.findIndex(u => u.id === payload.id)
    const idy = state.quoting.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.quotes, idx, payload)
    } else if (idy >= 0) {
      Vue.delete(state.quoting, idy, payload)
    }
  },
  DELETE_QUOTES (state, payload) {
    for (let id of payload.ids) {
      const idx = state.quotes.findIndex(u => u.id === id)
      if (idx >= 0) {
        Vue.delete(state.quotes, idx)
      }
    }
  },
  ADD_QUOTE_DETAIL (state, payload) {
    state.quote.details.unshift(payload)
  },
  UPDATE_QUOTE_DETAIL (state, { payload, idx }) {
    if (idx >= 0) {
      Vue.set(state.quote.details, idx, payload)
    }
  },
  DELETE_QUOTE_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.quote.details, idx)
    }
  },
  DELETE_QUOTE_DETAILS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.quote.details.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.quote.details, idx)
      }
    }
  },
  SET_QUOTE (state, payload) {
    state.quote = payload.data
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_AMOUNT_VISIBLE (state, payload) {
    state.isModalAmountVisible = payload
  },
  SET_MODAL_ARTICLES_VISIBLE (state, payload) {
    state.isModalCategoriesVisible = payload
  },
  SET_MODAL_ASSIGNED_VISIBLE (state, payload) {
    state.isModalAssignedVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_FILTER_PARAMS_QUOTING (state, payload) {
    state.filterParamsQuoting = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.quotesCatalog[object] = payload.data
  },
  SET_QUOTES_CATALOG (state, payload) {
    state.quotesCatalog = { ...state.quotesCatalog, ...payload }
  },
  SET_QUOTES_CANCELED_CATALOG (state, payload) {
    state.quotesCanceledCatalog = { ...state.quotesCanceledCatalog, ...payload }
  },
  SET_TAP (state, payload) {
    state.tap = payload
  }
}

const actions = {
  initQuote ({ commit }, payload) {
    commit('INIT_QUOTE_DETAIL', payload)
  },
  async loadQuoting ({ commit }, payload) {
    app.$Progress.start()
    try {
      let customer = payload.customer ? `&customer_id=${payload.customer}` : ''
      const response = await axios.get(`quoteds?page=${payload.page}${state.filterParamsQuoting}${customer}&amount=[null]&stage=2&status!=5`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTING', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadQuotes ({ commit }, payload) {
    app.$Progress.start()
    try {
      let customer = payload.customer ? `&customer_id=${payload.customer}` : ''
      const response = await axios.get(`quoteds?page=${payload.page}${state.filterParams}${customer}&amount!=[null]&stage=2&status!=5`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadQuotesCancelled ({ commit }, payload) {
    app.$Progress.start()
    try {
      let customer = payload.customer ? `&customer_id=${payload.customer}` : ''
      const response = await axios.get(`quoteds?page=${payload.page}${state.filterParams}${customer}&stage=2&status=5`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async updateQuoteAmount ({ commit }, payload) {
    const quote = {
      amount: payload.amount,
      currency: parseInt(payload.currency)
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`quoteds/${payload.id}/amount`, quote)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTE', response.data)
        commit('UPDATE_QUOTING_TO_QUOTED', response.data)
        commit('SET_MODAL_AMOUNT_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async assignedProject ({ commit }, payload) {
    let formData = new FormData()
    formData.append('detailing_weeks', payload.project.detailing_weeks)
    formData.append('joist_weeks', payload.project.joist_weeks)
    formData.append('structure_weeks', payload.project.structure_weeks)
    formData.append('approve_shop_drawings_weeks', payload.project.approve_shop_drawings_weeks)
    formData.append('delivery_deadline', moment(payload.project.delivery_deadline).format('YYYY-MM-DD'))

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`quotations/${payload.project.id}/assigned`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTE_ACTION_STATE_CHANGE', response.data)
        commit('SET_MODAL_ASSIGNED_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteQuote ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`quotations/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTE', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteQuotes ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`quotes/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTES', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addQuoteDetail ({ commit }, payload) {
    const QuoteDetail = {
      category_id: parseInt(payload.detail.category.id),
      category: payload.detail.category,
      quantity: payload.detail.quantity,
      unit_measurement: payload.detail.unit_measurement,
      quantity2: payload.detail.quantity2,
      unit_measurement2: payload.detail.unit_measurement2,
      comments: payload.detail.comments,
      project_id: payload.project_id
    }
    app.$Progress.start()
    try {
      const response = await axios.post('project-details', QuoteDetail)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_QUOTE_DETAIL', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editQuoteDetail ({ commit }, payload) {
    const QuoteDetail = {
      id: payload.detail.id,
      category_id: parseInt(payload.detail.category.id),
      category: payload.detail.category,
      quantity: payload.detail.quantity,
      unit_measurement: payload.detail.unit_measurement,
      quantity2: payload.detail.quantity2,
      unit_measurement2: payload.detail.unit_measurement2,
      comments: payload.detail.comments,
      project_id: payload.detail.project_id
    }
    app.$Progress.start()

    try {
      const response = await axios.put(`project-details/${payload.detail.id}`, QuoteDetail)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_QUOTE_DETAIL', { payload: response.data, idx: payload.index })
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteQuoteDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`project-details/${payload.detail.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTE_DETAIL', payload.index)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteQuoteDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`project-details/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_QUOTE_DETAILS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadQuote ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionQuote ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`quotations/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        if (payload.action === 'assigned') {
          commit('UPDATE_QUOTE_ACTION_STATE_CHANGE', response.data)
        } else {
          commit('UPDATE_QUOTE_ACTION', response.data)
        }
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: `projects.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/quotes/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/quotes/${payload.id}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  applyFilterQuoting ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS_QUOTING', filter)
  },
  clearFilterQuoting ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS_QUOTING', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCatalogCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadQuotesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotes/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadQuotesCanceledCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotes/cancalled`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_QUOTES_CANCELED_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  loadCatalogAux ({ commit }, payload) {
    commit('SET_CATALOG', { object: payload.url, payload: payload })
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalAmountVisible ({ commit }, payload) {
    commit('SET_MODAL_AMOUNT_VISIBLE', payload)
  },
  setModalAssignedVisible ({ commit }, payload) {
    commit('SET_MODAL_ASSIGNED_VISIBLE', payload)
  },
  setChatVisible ({ commit }, payload) {
    commit('Rfis/SET_CHAT_VISIBLE', payload, { root: true })
  },
  setModalProjectVisible ({ commit }, payload) {
    commit('ToQuotes/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  },
  loadEmployees ({ commit, dispatch, getters }, payload) {
    dispatch('ToQuotes/loadEmployees', payload, { root: true })
  },
  setModalContactVisible ({ commit, dispatch, getters }, payload) {
    dispatch('ProjectContacts/setModalContactVisible', { payload }, { root: true })
  },
  setTap ({ commit }, payload) {
    commit('SET_TAP', payload)
  }
}

const getters = {
  quote: state => state.quote,
  quotes: state => state.quotes,
  quoting: state => state.quoting,
  tap: state => state.tap,
  quotesCatalog: state => state.quotesCatalog,
  quotesCanceledCatalog: state => state.quotesCanceledCatalog,
  pagination: state => state.pagination,
  pagination_quoting: state => state.pagination_quoting,
  isModalVisible: state => state.isModalVisible,
  isModalAmountVisible: state => state.isModalAmountVisible,
  isModalCategoriesVisible: state => state.isModalCategoriesVisible,
  isModalAssignedVisible: state => state.isModalAssignedVisible,
  filterParams: state => state.filterParams,
  filterParamsQuoting: state => state.filterParamsQuoting,
  isModalContactVisible: (state, getters, rootState, rootGetters) => rootGetters['ProjectContacts/isModalContactVisible'],
  employees: (state, getters, rootState, rootGetters) => rootGetters['ToQuotes/employees']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
